/*
 * @Author: Fan
 * @Date: 2020-04-18 21:23:29
 * @description:
 * @LastEditors: zhuqiu
 */
import { ControlAttributeType, } from "../../../../form/typings";
import { formatterValueToSetStatus, formatterRequiredFormula, } from "../../../../form/utils";
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控件属性",
            keys: [
                "defaultValue",
                "readonlyFormula",
                "textAreaType",
                "placeholder",
                "currentMaxLength",
                "requiredFormula",
                "dataLinkage"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.LongText').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.LongText').toString() }),
        // 显示条件
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        // 只读条件
        readonlyCondition: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "readonlyCondition",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 默认值
        //perf:
        defaultValue: {
            options: {
                regexps: {
                    maxLength: {
                        len: 100000,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 100000 }).toString(),
                    },
                },
            },
        },
        // 提示文字
        placeholder: {
            options: {
                regexps: {
                    maxLength: {
                        len: 200,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 200 }).toString(),
                    },
                },
            },
        },
        // 文本最大长度
        maxLength: {
            options: {
                regexps: {
                    // required: "最大长度不能为空",
                    regexps: [
                        {
                            regexp: /^[1-9]\d*$/,
                            message: i18n.t('dataitem.ValidityErrTips2').toString(),
                        },
                        {
                            regexp: (value) => parseFloat(value) <= 100000,
                            message: i18n.t('dataitem.ValidityErrTips3', { num: 100000 }).toString(),
                        },
                    ],
                },
            },
        },
        // 富文本最大字数限制
        currentMaxLength: {
            options: {
                regexps: {
                    required: i18n.t('dataitem.ValidityErrTips4').toString(),
                    regexps: [
                        {
                            regexp: /^[1-9]\d*$/,
                            message: i18n.t('dataitem.ValidityErrTips2').toString(),
                        },
                        {
                            regexp: (value) => parseFloat(value) <= 2e7,
                            message: i18n.t('dataitem.ValidityErrTips5').toString() + 2e7,
                        },
                    ],
                },
            },
        },
        textAreaType: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "longText",
                        label: i18n.t('dataitem.Textarea').toString(),
                    },
                    {
                        value: "current",
                        label: i18n.t('dataitem.Richtext').toString(),
                    },
                ],
                hideField: (attr) => {
                    if (!attr || attr === "longText") {
                        return ["currentMaxLength"];
                    }
                    else {
                        return ["placeholder", "maxLength"];
                    }
                    // (attr ? [] : ["imageQuality"])
                },
            },
        },
    },
};
